import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";

// Shared, nesting-aware overlay z-index lives in the design system so DS and UI overlays stack
// correctly against each other during migration; see design-system/src/lib/overlay-z-index.tsx.
import { useOverlayZIndex } from "@tellescope/design-system";

import { cn } from "../../lib/utils";

export const DialogOverlay = ({ className, ...props }: ComponentProps<typeof DialogPrimitive.Overlay>) => {
  const { style, className: zClassName } = useOverlayZIndex("modalOverlay");

  return (
    <DialogPrimitive.Overlay
      data-slot="dialog-overlay"
      style={style}
      className={cn(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 bg-black/50",
        zClassName,
        className
      )}
      {...props}
    />
  );
};
